module.exports = __webpack_public_path__ + "static/dl1-screen3-1a385617eb30c89f0cf95c7811a87cc4.png";